module.exports = __webpack_public_path__ + "img/city-of-philadelphia-logo.6fc34e99.png";